module.exports = __webpack_public_path__ + "img/550-42dfb3.png";